(function () {
  var selector =
    '.product-detail-accordion--size-chart .cc-accordion-item__content img, .size-chart__inner img';

  function setOrigin(img, clientX, clientY) {
    var rect = img.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var x = ((clientX - rect.left) / rect.width) * 100;
    var y = ((clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
  }

  function clearZoomedImages(except) {
    document.querySelectorAll(selector + '.is-zoomed').forEach(function (img) {
      if (img !== except) img.classList.remove('is-zoomed');
    });
  }

  document.addEventListener(
    'mousemove',
    function (event) {
      var img = event.target.closest(selector);
      if (!img) return;
      setOrigin(img, event.clientX, event.clientY);
    },
    { passive: true }
  );

  var touchStart = { x: 0, y: 0, time: 0, img: null };

  document.addEventListener(
    'touchstart',
    function (event) {
      var img = event.target.closest(selector);

      if (!img) {
        clearZoomedImages();
        return;
      }

      var touch = event.touches[0];
      if (!touch) return;

      touchStart = {
        x: touch.clientX,
        y: touch.clientY,
        time: Date.now(),
        img: img,
      };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      var img = touchStart.img;
      if (!img) return;

      var touch = event.changedTouches[0];
      if (!touch) return;

      var dx = Math.abs(touch.clientX - touchStart.x);
      var dy = Math.abs(touch.clientY - touchStart.y);
      var dt = Date.now() - touchStart.time;

      touchStart.img = null;

      if (dx > 12 || dy > 12 || dt > 350) return;

      if (img.classList.contains('is-zoomed')) {
        img.classList.remove('is-zoomed');
        return;
      }

      clearZoomedImages(img);
      setOrigin(img, touch.clientX, touch.clientY);
      img.classList.add('is-zoomed');
    },
    { passive: true }
  );
})();

/* Tablet PDP: navegar galería cuando el tema apila imágenes (>=768) */
(function () {
  var mq = window.matchMedia('(min-width: 768px) and (max-width: 1024px)');

  function getSlides(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('.theme-img'));
  }

  function ensureCurrent(slides) {
    var current = slides.find(function (slide) {
      return slide.classList.contains('current-img');
    });
    if (!current && slides[0]) {
      slides[0].classList.add('current-img');
      current = slides[0];
    }
    return current;
  }

  function showSlide(slides, index) {
    slides.forEach(function (slide, i) {
      slide.classList.toggle('current-img', i === index);
    });
  }

  function onNavClick(event) {
    if (!mq.matches) return;

    var btn = event.target.closest('.swiper-button-next, .swiper-button-prev');
    if (!btn) return;

    var media = btn.closest('.product-area__media');
    if (!media) return;

    var gallery = media.querySelector('.theme-gallery');
    var swiper = media.querySelector('.swiper-container');
    if (!gallery || !swiper || swiper.classList.contains('swiper-container-horizontal')) return;

    var slides = getSlides(gallery);
    if (slides.length < 2) return;

    event.preventDefault();
    event.stopPropagation();

    var current = ensureCurrent(slides);
    var index = slides.indexOf(current);
    if (index < 0) index = 0;

    if (btn.classList.contains('swiper-button-next')) {
      index = (index + 1) % slides.length;
    } else {
      index = (index - 1 + slides.length) % slides.length;
    }

    showSlide(slides, index);
  }

  document.addEventListener('click', onNavClick, true);
})();
